<template>
  <div class="bg-white">
    <HeaderContent />

    <div class="lg:flex md:flex gap-3 container">
      <div class="lg:w-4/6 md:w-4/6 w-full">
        <AboutCourse />
        <CourseContent />
      </div>

      <div class="lg:w-2/6 md:w-3/6 w-full pb-12">
        <RightSection />
      </div>
    </div>
  </div>
</template>
<script>
import HeaderContent from "./components/HeaderContent";
import RightSection from "./components/RightSection";
import AboutCourse from "./components/AboutCourse";
import CourseContent from "./components/CourseContent";
import "../../scss/index.scss";
export default {
  data() {
    return {};
  },
  components: {
    HeaderContent,
    RightSection,
    AboutCourse,
    CourseContent,
  },
};
</script>
